import { useSelector } from 'react-redux'
import timeZonesEnam from '@/constant/timeZonesEnam'

export const usePlatformTimeZone = (): string =>
  useSelector(
    (store: { settings?: { custom?: { timezone?: string } } }) =>
      store.settings?.custom?.timezone,
  ) ?? timeZonesEnam.GMT_MINUS_3
